import React from "react";
import { View, StyleSheet } from "react-native";
import { WebView } from "react-native-webview";

export default function MapEmbedScreen({ lat, lng }) {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

    // Sanitize lat/lng to prevent XSS
    const safeLat = parseFloat(lat) || 0;
    const safeLng = parseFloat(lng) || 0;

    const mapHtml = `
   <!DOCTYPE html>
    <html>
    <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Clean Map + Marker</title>
        <style>
        body, html { margin:0; padding:0; height:100vh; width:100%; overflow:hidden; }
        #map { width:100%; height:100%; }
        </style>
    </head>
    <body>
        <div id="map"></div>

        <script>
        const lat = ${safeLat};
        const lng = ${safeLng};

        function initMap() {
            const map = new google.maps.Map(document.getElementById("map"), {
                center: { lat: lat, lng: lng },
                zoom: 17,                     // a bit closer so the marker looks nice
                mapTypeId: "hybrid",
                disableDefaultUI: true,       // no buttons, no logo bar
                gestureHandling: "none",
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                styles: [
                    {
                        featureType: "poi.business",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "poi.attraction",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "poi.government",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "poi.medical",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "poi.place_of_worship",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "poi.school",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    },
                    {
                        featureType: "poi.sports_complex",
                        elementType: "all",
                        stylers: [{ visibility: "off" }]
                    }
                ]
            });

            new google.maps.Marker({
                position: { lat: lat, lng: lng },
                map: map,
            });
        }
        </script>

        <script async
        src="https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap">
        </script>
    </body>
    </html>
  `;

    return (
        <View style={styles.container}>
            <WebView
                originWhitelist={["https://*"]}
                source={{ html: mapHtml }}
                style={styles.webview}
                javaScriptEnabled={true}
                domStorageEnabled={true}
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        height: 200,
        // Add padding/margin as needed
    },
    webview: {
        flex: 1,
    },
});
